import React from 'react'
import useStyles from './Style'
import { ComponentsProps } from './Type'

const VisitorFormProgress: React.FC<ComponentsProps> = ({ size }) => {
  const classes = useStyles({ size })
  return (
    <div className={classes.progressBar}>
      <div className={classes.line} />
    </div>
  )
}

export default VisitorFormProgress
